import React from "react";
import { useNavigate, NavLink, Navigate } from "react-router-dom";
import PageTitles from "./PageTitles";


const TurnosSite = () => {
    const navigate = useNavigate();


    
    return (
        <>
       <div class="container text-center indexContent" >
        <PageTitles texto="Turnos" icono="./icon_header_turnos.svg" retorno="/"/>
        
           { /*<div class="row">
                <div class="col">
                <img class="imgBackIcon" src="./back-go.svg" onClick={()=>{navigate("/")}}/>

                    <img className="imageClip" src="./title-turnos.png"/>
                </div>
            </div>*/}
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonClip" onClick={()=> navigate("/turnossaludmenu")}>Salud</button>
                </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonClip" onClick={()=> navigate("/turnosdocumentacionmenu")}>Documentaci&oacute;n</button>
               
                </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonClip" onClick={()=> navigate("/turnoszoonosismenu")}>Zoonosis</button>
               
                </div> 
                </div>
            </div>
            <div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonInvertedClip" onClick={()=> navigate("/misturnoslista")}>Mis turnos</button>
               
                </div> 
                </div>
            </div>
            {/*<div class="row">
                <div class="col">
                <div className="buttonContainer">
                <button className="buttonClip" onClick={()=> navigate("/tramitescancela")}>Mis tramites</button>
               
                </div> 
                </div>
        </div>*/}
       </div>
        
        </>

    );
}

export default TurnosSite;